import { render, staticRenderFns } from "./weixin.vue?vue&type=template&id=c918991e&scoped=true&"
import script from "./weixin.vue?vue&type=script&lang=js&"
export * from "./weixin.vue?vue&type=script&lang=js&"
import style0 from "./weixin.vue?vue&type=style&index=0&id=c918991e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c918991e",
  null
  
)

export default component.exports